export default __webpack_public_path__ + "static/media/stress_free.0de35969.png";